import { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import type { Components } from 'react-markdown'

import './readme.scss'

function Readme() {
  const [markdown, setMarkdown] = useState('')

  useEffect(() => {
    document.title = 'README.md - Dwain Portfolio'

    // Fetch the README.md file
    fetch('/README.md')
      .then(response => response.text())
      .then(text => setMarkdown(text))
      .catch(error => {
        console.error('Failed to load README:', error)
        setMarkdown('# Error\n\nFailed to load README.md')
      })
  }, [])

  return (
    <main className='page-readme'>
      <div className='readme-header'>
        <div className='file-icon'>📄</div>
        <div className='file-info'>
          <div className='file-name'>README.md</div>
          <div className='file-path'>dwain/README.md</div>
        </div>
      </div>

      <div className='readme-content'>
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            // Custom component renderers for better styling
            h1: ({node, ...props}) => <h1 className="md-h1" {...props} />,
            h2: ({node, ...props}) => <h2 className="md-h2" {...props} />,
            h3: ({node, ...props}) => <h3 className="md-h3" {...props} />,
            h4: ({node, ...props}) => <h4 className="md-h4" {...props} />,
            h5: ({node, ...props}) => <h5 className="md-h5" {...props} />,
            h6: ({node, ...props}) => <h6 className="md-h6" {...props} />,
            p: ({node, ...props}) => <p className="md-p" {...props} />,
            a: ({node, ...props}) => <a className="md-link" target="_blank" rel="noopener noreferrer" {...props} />,
            code: ({node, className, children, ...props}: any) => {
              const isInline = !className
              return isInline
                ? <code className="md-inline-code" {...props}>{children}</code>
                : <code className={`md-code-block ${className || ''}`} {...props}>{children}</code>
            },
            pre: ({node, ...props}) => <pre className="md-pre" {...props} />,
            ul: ({node, ...props}) => <ul className="md-ul" {...props} />,
            ol: ({node, ...props}) => <ol className="md-ol" {...props} />,
            li: ({node, ...props}) => <li className="md-li" {...props} />,
            blockquote: ({node, ...props}) => <blockquote className="md-blockquote" {...props} />,
            table: ({node, ...props}) => <table className="md-table" {...props} />,
            thead: ({node, ...props}) => <thead className="md-thead" {...props} />,
            tbody: ({node, ...props}) => <tbody className="md-tbody" {...props} />,
            tr: ({node, ...props}) => <tr className="md-tr" {...props} />,
            td: ({node, ...props}) => <td className="md-td" {...props} />,
            th: ({node, ...props}) => <th className="md-th" {...props} />,
            img: ({node, ...props}) => <img className="md-img" {...props} />,
            hr: ({node, ...props}) => <hr className="md-hr" {...props} />,
          }}
        >
          {markdown}
        </ReactMarkdown>
      </div>
    </main>
  )
}

export default Readme
